import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {Media} from "../../models/media";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {MediaSelectionModal} from "../../modals/media-selection-modal/media-selection-modal.component";
import {environment} from "../../../environments/environment";

@Component({
  selector: 'app-media-multiple-selection',
  templateUrl: './media-multiple-selection.component.html',
  styleUrls: ['./media-multiple-selection.component.scss']
})
export class MediaMultipleSelectionComponent implements OnInit {

  @Input() title: string;
  @Input() media: Array<Media>;
  @Input() code: string;

  @Input() mediaSelectedArray: Array<Media> = [];

  @Output() mediaSelected: EventEmitter<Media> = new EventEmitter<Media>();
  @Output() mediaRemoved: EventEmitter<Media> = new EventEmitter<Media>();

  environment = environment;

  constructor(
    private modalService: NgbModal
  ) {
  }

  ngOnInit() {
    this.mediaSelectedArray = this.mediaSelectedArray.map(m => this.media.find(me => me._id === m._id));
  }

  onShowModal() {
    let modalRef;

    modalRef = this.modalService.open(MediaSelectionModal, {size: 'lg'});
    modalRef.componentInstance.media = this.media;
    modalRef.componentInstance.code  = this.code;
    modalRef.result.then(media => {
      const index = this.mediaSelectedArray.findIndex(m => m._id === media._id);

      if (index === -1) {
        this.mediaSelectedArray.push(media);
        this.mediaSelected.emit(media);
      }
    }, dismiss => {
    });
  }

  onRemoveMedia(media) {
    const index = this.mediaSelectedArray.findIndex(m => m._id === media._id);

    if (index !== -1)
      this.mediaSelectedArray.splice(index, 1);

    this.mediaRemoved.emit(media);
  }
}
